import { useHistory, Link } from 'react-router-dom'

import { Button, Page } from '../../components'
import { withAuthCheck } from '../../hoc'
import pages from '..'
import { login } from '../../lib/icp'
import { useTranslation } from '../../hooks'

import styles from './Login.module.scss'

const Register = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const signUp = () => {
    login(() => {
      history.push(pages.account.path)
    })
  }

  return (
    <Page title={`${t('loginPageTitle')} | DSocial`}>
      <div className={styles.login_wrap}>
        <div className={styles.login_wrap_head}>
          <h1 className={styles.login_wrap_head_title}>
            {t('loginPageTitle')}
          </h1>
          <Link to="/" className={styles.login_wrap_head_box}>
            <img
              src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688376988591_Frame (1).png"
              alt=""
            />
          </Link>

          {/* <img
            src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1688375942768_Frame.png"
            alt=""
          /> */}
        </div>

        <p className={styles.login_wrap_first_title}>
          {t('loginIfNotRegistered')}
        </p>

        <p className={styles.login_wrap_first_button}>
          <Button onClick={signUp}>{t('loginSignUpButton')}</Button>
        </p>

        <p className={styles.login_wrap_first_title}>
          {t('loginIfRegistered')}
        </p>

        <p className={styles.login_wrap_first_button}>
          <Button onClick={signUp}>{t('loginButton')}</Button>
        </p>
      </div>
    </Page>
  )
}

export default withAuthCheck(Register, true)
